export function wrapImageBase64(stringDataInBase64: string, defaultImagePath: string): string {
  if (stringDataInBase64) {
    return `data:image/png;base64,${stringDataInBase64}`;
  }
  return defaultImagePath;
}
